export default __webpack_public_path__ + "static/media/screencapture-ema-jone-78050-web-app-2021-10-03-23_10_55 (1).60b20175.png";